module.exports = __webpack_public_path__ + "static/img/complete_logo.0586165.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/complete_logo.png
// module id = 04P6
// module chunks = 0